import {
    $, addFilter, addAction, INIT,
} from '@situation/setdesign.util';

addAction(INIT, () => {
    const $homeHeroFooter = $('.home-hero__footer');
    if (!$homeHeroFooter.length) {
        return;
    }

    addFilter('css-vars/register', (styles) => ({
        ...styles,
        'home-hero-footer-height': () => `${$homeHeroFooter.outerHeight(true)}px`,
    }));
});
